module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fake_player_button", [["span",{"class":"fake-play background-color-3 text-color-1"},[["span",{"class":"arr"}],["textNode",{"text":" "}],["span",{"class":"txt"},[["textNode",{"text":"play welcome video"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/player/fakeButton.tpl
// module id = 768
// module chunks = 4